var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getCurrentMagentoClient } from "@jti/magento";
const fetchOrderDetails = (orderId, isFreeTrial = false) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const orderDetailsObject = yield getCurrentMagentoClient(isFreeTrial).getCustomerOrderDetails(orderId);
    const orderDetailsItems = (_b = (_a = orderDetailsObject === null || orderDetailsObject === void 0 ? void 0 : orderDetailsObject.customer) === null || _a === void 0 ? void 0 : _a.orders) === null || _b === void 0 ? void 0 : _b.items;
    if (!orderDetailsItems.length) {
        throw new Error("no items found in selected order");
    }
    const orderDetails = orderDetailsItems[0];
    if (!/new|payment failed/i.test(orderDetails.status)) {
        throw new Error("selected order is in incorrect status");
    }
    return orderDetails;
});
export default fetchOrderDetails;
//# sourceMappingURL=fetchOrderDetails.js.map